module.exports = __webpack_public_path__ + "img/google-plus.5bc81aba.svg";